var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight}}),_vm._t("default",null,{"ticks":_vm.ticks,"cellsAlive":_vm.cellsAlive,"cellsDead":_vm.rows * _vm.cols - _vm.cellsAlive})],2)}
var staticRenderFns = []

export { render, staticRenderFns }